// create a container and set the full-size image as its background
function createOverlay(image, srcOverride) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', srcOverride || image.currentSrc || image.src);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  }

  return overlay;
};

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading-overlay__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
};
// inside quick shop, find the image of the currently selected variant
function getVariantZoomSrc(image) {
  const modal = image.closest('quick-add-modal');
  if (!modal) return null; // normal page: keep default behavior

  const variantId = modal.querySelector('form input[name="id"]')?.value;
  const json = modal.querySelector(
    'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
  );
  if (!variantId || !json) return null;

  try {
    const variant = JSON.parse(json.textContent).find(v => String(v.id) === String(variantId));
    const mediaId = variant?.featured_media?.id;
    if (!mediaId) return null;
    const img = modal.querySelector(`li[id$="-${mediaId}"] img`);
    return img ? (img.currentSrc || img.src) : null;
  } catch (e) {
    return null;
  }
}
function magnify(image,zoomRatio){
  if(!window.matchMedia("(hover: hover) and (pointer: fine)").matches)return;
  const overlay2 = createOverlay(image, getVariantZoomSrc(image));
  overlay2.onclick=()=>overlay2.remove(),
  overlay2.onmousemove=event=>moveWithHover(image,event,zoomRatio),
  overlay2.onmouseleave=()=>overlay2.remove()
}

function isMobileDevice() {
  return /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function enableZoomOnHover(zoomRatio){
  document.querySelectorAll(".image-magnify-hover").forEach(image=>{
    image.onclick=event=>{magnify(image,zoomRatio),moveWithHover(image,event,zoomRatio)}
  })
}
enableZoomOnHover(2);

function initMobileTapZoom() {
  if (!isMobileDevice()) return;
  const images = document.querySelectorAll('.product-media-modal__dialog .global-media-settings');

  images.forEach(img => {
    img.addEventListener('click', (event) => {
      console.log('IM CLICKEDDDD!');
      setTimeout(()=>{
        const container = img.parentElement;
        const isZoomed = img.classList.contains('is-zoomed');

        if (!isZoomed) {
          const rect = img.getBoundingClientRect();
          const xPercent = (event.clientX - rect.left) / rect.width;
          const yPercent = (event.clientY - rect.top) / rect.height;

          img.classList.add('is-zoomed');

          requestAnimationFrame(() => {
            container.scrollLeft = (img.scrollWidth - container.clientWidth) * xPercent;
            container.scrollTop = (img.scrollHeight - container.clientHeight) * yPercent;
          });
        } else {
          img.classList.remove('is-zoomed');
          container.scrollLeft = 0;
          container.scrollTop = 0;
        }
      },100);
    });
  });
}

document.addEventListener('DOMContentLoaded', initMobileTapZoom);